import React from 'react';

export default props => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 10">
    <path d="M100,3.65c-24.55,20-73.35-16.36-100,1.4v5H100Z" />
  </svg>
);
